export const palettes = [
    { id: 'ocean', name: 'Ocean Breeze', colors: ['#2B6777', '#4C9F9F', '#F7C59F', '#ECECEC'] },
    { id: 'sunset', name: 'Sunset Glow', colors: ['#D1495B', '#EDAE49', '#EDE3D9', '#C9CCD5'] },
    { id: 'mint', name: 'Cool Mint', colors: ['#2E8B57', '#3CB371', '#F5F5DC', '#696969'] },
    { id: 'sage', name: 'Muted Sage', colors: ['#6B8E23', '#9ACD32', '#F5DEB3', '#FAF0E6'] },
    { id: 'berry', name: 'Berry Pop', colors: ['#6A0DAD', '#E0115F', '#FFE5B4', '#2F4F4F'] },
    { id: 'sky', name: 'Sky High', colors: ['#87CEEB', '#4682B4', '#FFFFFF', '#1C1C1C'] }
]

export function renderPalettePickerSummary(value: string): { label: string; colors: string[] } | null {
    const palette = palettes.find(p => p.id === value)
    return palette ? { label: palette.name, colors: palette.colors } : null
}
